import { atom } from "recoil";
import { SelectedRowsToDelete } from "../types";

export const editRolePermissionsState = atom({
  key: "editRolePermissionsState",
  default: false,
});


export const selectedRowsStateToDeleteOF = atom<SelectedRowsToDelete | undefined>(
  {
    key: "selectedRowsStateToDeleteOF",
    default: undefined,
  }
);

export const updatedPermissionAtom = atom({
  key: "updatedPermissionAtom",
  default: []
});